export default __webpack_public_path__ + "static/media/laza_s.23b1aa73.jpg";